/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeedCommonThemesRequest
 */
export interface SeedCommonThemesRequest {
    /**
     * 
     * @type {string}
     * @memberof SeedCommonThemesRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the SeedCommonThemesRequest interface.
 */
export function instanceOfSeedCommonThemesRequest(value: object): value is SeedCommonThemesRequest {
    return true;
}

export function SeedCommonThemesRequestFromJSON(json: any): SeedCommonThemesRequest {
    return SeedCommonThemesRequestFromJSONTyped(json, false);
}

export function SeedCommonThemesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeedCommonThemesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function SeedCommonThemesRequestToJSON(json: any): SeedCommonThemesRequest {
    return SeedCommonThemesRequestToJSONTyped(json, false);
}

export function SeedCommonThemesRequestToJSONTyped(value?: SeedCommonThemesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effectTenantId': value['effectTenantId'],
    };
}

